import HTTP from "@/http-common";
import router from "@/router";
import { formatNbnSqDisplay } from "@/utils/nbnSqDisplay";

export const state = {
  sogOrders: [],
  selectedOrder: {},
  sqResult: {},
  sq5gResult: {
    sqId: "",
    location: []
  },
  radiusUserNameResults: [],
  sqNbnResult: {},
  serviceTestResult: {},
  hasSectorID: false,
  hasNtd: false,
  orderType: "",
  formattedSQResult: {
    serviceabilityClass: "",
    serviceability: "",
    csaid: "",
    region: "",
    accessTechnology: "",
    latitude: "",
    longitude: ""
  },
  optusOrderDetails: {
    orderID: "",
    orderType: "",
    locationID: "",
    orderStatus: "",
    plannedCompletionDate: "",
    priID: "",
    uniDSL: "",
    bandwidthProfile: "",
    avcd: ""
  },
  ntdDetails: [],
  supportingResources: [],
  nfas: [],
  unidPorts: [],
  locationID: null,
  addressQueryResult: {},
  customizedOfferResult: {},
  wholesalers: [],
  msnList: [],
  simList: [],
  msnVal: {},
  sim: {},
  ratePlans5G: [],
  ubCustomers: [],
  isOriginal: false,
  hasFreePort: false,
  editForm: false,
  isPendingServiceability: false,
  isReferenceInvalid: false,
  hasActiveServices: false,
  isLayer3: false,
  isHistoricalOrder: false,
  isVonexNetwork: true,
  isOldOrder: false,
  isDuplicate: false,
  showFibreCheckbox: false,
  transferredDate: "",
  isInternalWholesaler: false,
  reportData: []
};

export const getters = {
  hasActiveServices: state => {
    return state.hasActiveServices;
  },
  isPendingServiceability: state => {
    return state.isPendingServiceability;
  },
  isOriginal: state => {
    return state.isOriginal;
  },
  editForm: state => {
    return state.editForm;
  },
  ubCustomers: state => {
    return state.ubCustomers;
  },
  ratePlans5G: state => {
    return state.ratePlans5G;
  },
  msnList: state => {
    return state.msnList;
  },
  simList: state => {
    return state.simList;
  },
  msnVal: state => {
    return state.msnVal;
  },
  sim: state => {
    return state.sim;
  },
  hasSectorID: state => {
    return state.hasSectorID;
  },
  orderType: state => {
    return state.orderType;
  },
  sogOrders: state => {
    return state.sogOrders;
  },
  selectedOrder: state => {
    return state.selectedOrder;
  },
  locationID: state => {
    return state.locationID;
  },
  ntdDetails: state => {
    return state.ntdDetails;
  },
  supportingResources: state => {
    return state.supportingResources;
  },
  nfas: state => {
    return state.nfas;
  },
  addressQueryResult: state => {
    return state.addressQueryResult;
  },
  sqResult: state => {
    return state.sqResult;
  },
  formattedSQResult: state => {
    return state.formattedSQResult;
  },
  customizedOfferResult: state => {
    return state.customizedOfferResult;
  },
  optusOrderDetails: state => {
    return state.optusOrderDetails;
  },
  hasNtd: state => {
    return state.hasNtd;
  },
  unidPorts: state => {
    return state.unidPorts;
  },
  wholesalers: state => {
    return state.wholesalers;
  },
  sq5gResult: state => {
    return state.sq5gResult;
  },
  sqNbnResult: state => {
    return state.sqNbnResult;
  },
  hasFreePort: state => {
    return state.hasFreePort;
  },
  serviceTestResult: state => {
    return state.serviceTestResult;
  },
  isReferenceInvalid: state => {
    return state.isReferenceInvalid;
  },
  isLayer3: state => {
    return state.isLayer3;
  },
  isHistoricalOrder: state => {
    return state.isHistoricalOrder;
  },
  radiusUserNameResults: state => {
    return state.radiusUserNameResults;
  },
  isVonexNetwork: state => {
    return state.isVonexNetwork;
  },
  isOldOrder: state => {
    return state.isOldOrder;
  },
  isDuplicate: state => {
    return state.isDuplicate;
  },
  showFibreCheckbox: state => {
    return state.showFibreCheckbox;
  },
  transferredDate: state => {
    return state.transferredDate;
  },
  isInternalWholesaler: state => {
    return state.isInternalWholesaler;
  },
  reportData: state => {
    return state.reportData;
  }
};

export const mutations = {
  SET_ORIGINAL(state, val) {
    state.isOriginal = val;
  },

  SET_EDITING(state, val) {
    state.editForm = val;
  },

  SET_ORDER_TYPE(state, data) {
    state.orderType = data;
  },
  RESET_5G_SQ(state) {
    state.sq5gResult = {
      sqId: "",
      location: []
    };
  },
  SET_SOG_ORDERS(state, data) {
    state.sogOrders = data;
  },
  SET_SELECTED_ORDER(state, data) {
    state.selectedOrder = data;
  },
  SET_LOCATION_ID(state, data) {
    state.locationID = data;
  },
  SET_ADDRESS_QUERY_RESULT(state, data) {
    state.addressQueryResult = data;
  },
  SET_SQ_RESULT(state, data) {
    state.sqResult = data;
  },
  SET_FORMATTED_SQ_RESULT(state, data) {
    let serviceabilityClass = "";
    let csaid = "";
    let accessTechnology = "";
    let latitude = "";
    let longitude = "";
    state.nfas = [];
    state.ntdDetails = [];

    if (data.address) {
      data.address.additionalParameters.forEach(x => {
        switch (x.name) {
          case "latitude":
            latitude = x.value;
            break;
          case "longitude":
            longitude = x.value;
            break;
        }
      });
    }

    if (data.parameters) {
      data.parameters.parameter.forEach(x => {
        switch (x.name) {
          case "ServiceabilityClass":
            serviceabilityClass = x.value;
            break;
          case "CSAID":
            csaid = x.value;
            break;
          case "PrimaryAccessTechnology":
            accessTechnology = x.value;
            break;
        }

        if (x.name.includes("NFAS TC2")) {
          state.nfas.push(x);
        }
      });

      if (data.parameters.parameterGroup) {
        let count = 0;
        data.parameters.parameterGroup.forEach(x => {
          if (x.groupName.includes("NTD")) count = count + 1;
          x.parameter.map(z => {
            let sub = z.value.split(",");
            let index = sub[0].indexOf("=");
            if (z.name.includes("UNI")) {
              Object.assign(z, {
                name: z.name,
                port: `Port ${z.value.substring(
                  z.value.length - 2,
                  z.value.length - 1
                )}`,
                status: sub[0].substring(index + 1, sub[0].length)
              });
            }

            if (z.name.includes("NTD") || z.name.includes("Power")) {
              switch (z.name) {
                case "NTDType":
                  state.ntdDetails.push({
                    name: "Type",
                    value: z.value
                  });
                  break;
                case "BatteryPowerUnit":
                  state.ntdDetails.push({
                    name: "Battery Power Unit",
                    value: z.value
                  });
                  break;
                case "NTDLocation":
                  state.ntdDetails.push({
                    name: "Location",
                    value: z.value
                  });
                  break;
              }
            }
          });
        });

        if (count > 0) state.hasNtd = true;

        if (serviceabilityClass === "23" || serviceabilityClass === "24") {
          if (data.parameters && data.parameters.parameterGroup) {
            let freePortCount = 0;
            data.parameters.parameterGroup.forEach(x => {
              x.parameter.forEach(y => {
                if (y.status.toLowerCase() === "free")
                  freePortCount = freePortCount + 1;
              });
            });

            state.hasFreePort = freePortCount > 0;
          }
        }
      }
    }

    state.nfas.forEach(x => {
      let split = x.name.split(" ");
      x.speed = parseInt(split[2].substring(0, split[2].indexOf("Mbps")));
    });

    state.nfas.sort(function(a, b) {
      return a.speed - b.speed;
    });

    state.formattedSQResult = {
      serviceabilityClass: serviceabilityClass,
      serviceability: data.serviceability,
      csaid: csaid,
      region: data.region,
      accessTechnology: accessTechnology,
      latitude: latitude,
      longitude: longitude
    };
  },
  SET_FORMATTED_SQ_NBN_RESULT(state, data) {
    state.nfas = [];
    state.ntdDetails = [];
    state.uniDetails = [];
    state.supportingResources = [];
    state.sqNbnResult = data || {};

    const address = data && data.address;
    const display = formatNbnSqDisplay(data && data.sq, address);
    if (!display) {
      state.isPendingServiceability = false;
      state.hasNtd = false;
      state.formattedSQResult = {
        serviceabilityClass: "",
        serviceability: "",
        csaid: "",
        region: "",
        accessTechnology: "",
        latitude: address && address.latitude != null ? address.latitude : "",
        longitude: address && address.longitude != null ? address.longitude : "",
        serviceabilityDate: ""
      };
      return;
    }

    data.sq = display.sq;
    state.nfas = display.nfas;
    state.hasNtd = display.hasNtd;
    state.isPendingServiceability = display.isPending;
    state.formattedSQResult = display.formatted;

    const technology =
      (display.sq.siteRestriction &&
        display.sq.siteRestriction.supportingTechnology) ||
      {};
    if (
      technology.alternativeTechnology !== undefined &&
      router.currentRoute.fullPath !== "/service-qualification-nbn"
    ) {
      state.showFibreCheckbox =
        technology.serviceabilityClass !== "3" &&
        (technology.alternativeTechnology ===
          "Fibre on-demand available for higher speeds" ||
          String(technology.alternativeTechnology).includes("Changed to Fibre"));
    }

    const resources =
      (display.sq.siteRestriction &&
        display.sq.siteRestriction.supportingResource) ||
      [];
    if (resources.length > 0) {
      state.hasActiveServices = resources
        .map(x => x.NBNServiceStatus)
        .some(x => x == "Line In Use");
    }
  },
  RESET_FORMATTED_SQ_NBN_RESULT(state) {
    state.sqNbnResult = {};
  },
  RESET_FORMATTED_SQ_RESULT(state) {
    state.formattedSQResult = {
      serviceabilityClass: "",
      csaid: ""
    };
  },
  SET_CUSTOMIZED_OFFER_RESULT(state, data) {
    state.customizedOfferResult = data;
  },
  UPDATE_OFFER_CONTACT(state, data) {
    let subUnitType = state.sqResult.address.additionalParameters.filter(
      x => x.name === "subUnitType"
    );
    let subUnitNr = state.sqResult.address.additionalParameters.filter(
      x => x.name === "subUnitNr"
    );
    let streetNrFirst = state.sqResult.address.additionalParameters.filter(
      x => x.name === "streetNrFirst"
    );
    let streetName = state.sqResult.address.additionalParameters.filter(
      x => x.name === "streetName"
    );
    let streetType = state.sqResult.address.additionalParameters.filter(
      x => x.name === "streetType"
    );
    let suburb = state.sqResult.address.additionalParameters.filter(
      x => x.name === "suburb"
    );
    let stateOrProvince = state.sqResult.address.additionalParameters.filter(
      x => x.name === "stateOrProvince"
    );
    let postcode = state.sqResult.address.additionalParameters.filter(
      x => x.name === "postcode"
    );
    let formattedAddress = state.sqResult.address.additionalParameters.filter(
      x => x.name === "formattedAddress"
    );

    let firstLine = `${subUnitType.length > 0 ? subUnitType[0].value : ""} ${
      subUnitNr.length > 0 ? subUnitNr[0].value : ""
    } ${streetNrFirst.length > 0 ? streetNrFirst[0].value : ""} ${
      streetName.length > 0 ? streetName[0].value : ""
    } ${streetType.length > 0 ? streetType[0].value : ""}`;

    state.customizedOfferResult.deliveryAddress = data.shipping.fullAddress;
    state.customizedOfferResult.sqAddress = formattedAddress[0].value;
    state.customizedOfferResult.baseOffer.serviceFeatures.forEach(x => {
      switch (x.featureKey) {
        case "NBN_SERVICE_SPEC:CONTACT_NAME":
          x.value.value = `${data.firstName} ${data.lastName}`;
          break;
        case "NBN_SERVICE_SPEC:CONTACT_NUMBER":
          x.value.value = data.number;
          break;
        case "NBN_SERVICE_SPEC:CONTACT_EMAIL":
          x.value.value = data.email;
          break;
      }
    });

    if (data.shippingType === "Alternate Address") {
      state.customizedOfferResult.baseOffer.serviceFeatures.forEach(x => {
        switch (x.featureKey) {
          case "NBN_SERVICE_SPEC:SHIPPING_ADDRESS":
            x.value.value = "Alternate";
            break;
          case "NBN_SERVICE_SPEC:ADDRESS_LINE_1":
            x.value.value = data.shipping.addressLine;
            break;
          case "NBN_SERVICE_SPEC:SUBURB":
            x.value.value = data.shipping.suburb;
            break;
          case "NBN_SERVICE_SPEC:STATE":
            x.value.value = data.shipping.state;
            break;
          case "NBN_SERVICE_SPEC:POSTCODE":
            x.value.value = data.shipping.postcode.toString();
            break;
        }
      });
    } else {
      state.customizedOfferResult.baseOffer.serviceFeatures.forEach(x => {
        switch (x.featureKey) {
          case "NBN_SERVICE_SPEC:SHIPPING_ADDRESS":
            x.value.value = "Same";
            break;
          case "NBN_SERVICE_SPEC:ADDRESS_LINE_1":
            x.value.value = firstLine.trim();
            break;
          case "NBN_SERVICE_SPEC:SUBURB":
            x.value.value = suburb[0].value;
            break;
          case "NBN_SERVICE_SPEC:STATE":
            x.value.value = stateOrProvince[0].value;
            break;
          case "NBN_SERVICE_SPEC:POSTCODE":
            x.value.value = postcode[0].value;
            break;
        }
      });
    }
  },
  UPDATE_CUSTOMIZED_OFFER_RESULT(state, details) {
    if (details.field === "Contract Length")
      state.customizedOfferResult.baseOffer.offerFeatures.feature.contract_Term_length =
        details.value;
    else if (details.field === "Order Type") {
      if (details.value) {
        if (details.value.value === "Transition")
          state.customizedOfferResult.ordeR_TYPE = "ADD";
        else if (details.value.value === "Transfer")
          state.customizedOfferResult.ordeR_TYPE = "SERVICE TRANSFER";
        else
          state.customizedOfferResult.ordeR_TYPE = details.value.value.toUpperCase();
      }
    } else if (details.field === "Customer Email")
      state.customizedOfferResult.customerEmail = details.value;
    else if (details.field === "Wholesaler")
      state.customizedOfferResult.wholesalerAccount = details.value;
    else if (details.field === "CONTACT_NUMBER") {
      state.customizedOfferResult.operatorContactNumber = details.value;
      state.customizedOfferResult.baseOffer.serviceFeatures.forEach(x => {
        if (x.featureKey.includes(details.field)) x.value.value = details.value;
        //if (x.featureKey === "NBN_SERVICE_SPEC:CONTACT_NUMBER") x.value.value = details.value;
      });
    } else if (details.field === "Radius Username") {
      state.customizedOfferResult.radiusUsername = details.value;
    } else if (details.field === "Radius Password") {
      state.customizedOfferResult.radiusPassword = details.value;
    } else if (details.field === "Static IP") {
      state.customizedOfferResult.staticIP = details.value;
    } else {
      state.customizedOfferResult.baseOffer.serviceFeatures.forEach(x => {
        if (x.featureKey.includes(details.field)) {
          x.value.value = details.value;
        }
      });
    }
  },
  SET_ORDER_DETAILS(state, details) {
    details.parameters.forEach(x => {
      switch (x.name) {
        case "ORDER_ID":
          state.optusOrderDetails.orderID = x.value;
          break;
        case "ORDER_TYPE":
          state.optusOrderDetails.orderType = x.value;
          break;
        case "LOCATION_ID":
          state.optusOrderDetails.locationID = x.value;
          break;
        case "ORDER_STATUS":
          state.optusOrderDetails.orderStatus = x.value;
          break;
        case "PLANNED_COMPLETION_DATE":
          state.optusOrderDetails.plannedCompletionDate = x.value;
          break;
        case "PRI_ID":
          state.optusOrderDetails.priID = x.value;
          break;
        case "NTD":
          state.optusOrderDetails.uniDSL = x.value;
          break;
        case "BANDWIDTH_PROFILE":
          state.optusOrderDetails.bandwidthProfile = x.value;
          break;
        case "AVCD":
          state.optusOrderDetails.avcd = x.value;
          break;
      }
    });
  },
  RESET_HASNTD(state) {
    state.hasNtd = false;
  },
  SET_WHOLESALERS(state, data) {
    state.wholesalers = data;
  },
  SET_ENHANCED_SQ(state, data) {
    state.formattedSQResult = {
      serviceabilityClass: data.serviceabilityClass,
      csaid: data.csaid
    };
  },
  SET_SQ_5G(state, data) {
    let values = ["true", "Y", "1", "false", "N", "0", ""];
    state.sq5gResult = data;
    let count = 0;

    state.sq5gResult.location.forEach(x => {
      if (x.mobileQualification) {
        if (
          x.mobileQualification.serviceSpecCharacteristics.some(
            e => e.name === "SectorID"
          )
        ) {
          x.mobileQualification.serviceSpecCharacteristics.forEach(y => {
            if (y.name === "SectorID") {
              if (
                y.value === null ||
                values.some(z => z.toLowerCase() === y.value.toLowerCase())
              )
                count = count + 1;
            }
          });
        } else count = count + 1;
      }
    });

    if (state.sq5gResult.location) {
      state.sq5gResult.location[0].mobileQualification.serviceSpecCharacteristics.forEach(
        x => {
          if (x.name === "SectorID") state.hasSectorID = true;
        }
      );
    }
  },
  SET_SQ_NBN(state, data) {
    state.sqNbnResult = data;
  },
  RESET_HASSECTORID(state) {
    state.hasSectorID = false;
  },
  SET_MSN_LIST(state, data) {
    state.msnList = data;
    state.msnVal = state.msnList[0];
  },
  SET_SIM_LIST(state, data) {
    state.simList = data;
    if (state.simList) {
      state.sim = state.simList[0];
    }
  },
  SET_5G_RATE_PLANS(state, data) {
    state.ratePlans5G = data;
  },
  SET_UB_CUSTOMERS(state, data) {
    state.ubCustomers = data;
  },
  SET_SERVICE_TEST_RESULT(state, data) {
    state.serviceTestResult = data;
  },
  SET_REFERENCE_INVALID(state, data) {
    state.isReferenceInvalid = data;
  },
  SET_FEATURE(state, data) {
    if (data !== "" && data !== null) {
      state.isLayer3 = data.some(x => x.featureDescription === "Layer 3");
    } else state.isLayer3 = false;
  },
  RESET_FEATURE(state) {
    state.isLayer3 = false;
  },
  CHECK_HARDWARE_MODEM(state, order) {
    let historicalModem = [
      "Netcomm NL19MESH",
      "Netcomm NL20MESH",
      "2SG Standard VDSL Modem"
    ];
    let parsedOrder = JSON.parse(order.request);

    if (parsedOrder.HardwareRequired && parsedOrder.HardwareModem) {
      state.isHistoricalOrder = historicalModem.includes(
        parsedOrder.HardwareModem
      );
    } else state.isHistoricalOrder = false;
  },
  SET_RADIUS_USERNAME_RESULTS(state, results) {
    state.radiusUserNameResults = results;
  },
  RESET_RADIUS_USERNAME_RESULTS(state) {
    state.radiusUserNameResults = [];
  },
  SET_OLD_ORDER(state, value) {
    state.isOldOrder = value;
  },
  SET_IS_DUPLICATE(state, value) {
    state.isDuplicate = value;
  },
  SET_FIBRE_CHECKBOX(state, value) {
    state.showFibreCheckbox = value;
  },
  SET_TRANSFERRED_DATE(state, value) {
    state.transferredDate = value;
  },
  SET_USER_INTERNAL(state, value) {
    let internalWholesaler = [132, 138, 139, 61596, 10095];
    state.isInternalWholesaler = internalWholesaler.includes(value);
  },
  MAP_BANDWIDTH_PROFILE(state, items) {
    items.forEach(x => {
      if (
        x.technologyType !== null &&
        x.technologyType !== "" &&
        x.bandwidthProfile !== null &&
        x.bandwidthProfile !== ""
      ) {
        if (x.technologyType === "Fibre" || x.technologyType === "FTTP") {
          switch (x.bandwidthProfile) {
            case "D50_U20_Mbps_TC4_P":
              x.bandwidthProfile = "50/20 Mbps";
              break;
            case "D100_U40_Mbps_TC4_P":
              x.bandwidthProfile = "100/40 Mbps";
              break;
            case "Home Superfast":
              x.bandwidthProfile = "250/25 Mbps";
              break;
            case "D250_U100_Mbps_TC4_P":
              x.bandwidthProfile = "250/100 Mbps";
              break;
            case "Home Ultrafast":
              x.bandwidthProfile = "1000/50 Mbps";
              break;
            case "D1000_U400_Mbps_TC4_P":
              x.bandwidthProfile = "1000/400 Mbps";
              break;
            case "D25_U5_Mbps_TC4_P":
              x.bandwidthProfile = "25/5 Mbps";
              break;
            case "D25_U10_Mbps_TC4_P":
              x.bandwidthProfile = "25/10 Mbps";
              break;
            case "D12_U1_Mbps_TC4_P":
              x.bandwidthProfile = "12/1 Mbps";
              break;
          }
        } else if (x.technologyType === "FTTB" || x.technologyType === "FTTN") {
          if (x.technologyType === "FTTN" && x.fibreUpgrade === "Yes") {
            switch (x.bandwidthProfile) {
              case "D100_U40_Mbps_TC4_P":
                x.bandwidthProfile = "100/40 Mbps";
                break;
              case "D250_U100_Mbps_TC4_P":
                x.bandwidthProfile = "250/100 Mbps";
                break;
              case "Home Fast":
                x.bandwidthProfile = "100/20 Mbps";
                break;
              case "Home Superfast":
                x.bandwidthProfile = "250/25 Mbps";
                break;
              case "Home Ultrafast":
                x.bandwidthProfile = "1000/50 Mbps";
                break;
            }
          } else {
            switch (x.bandwidthProfile) {
              case "D12_U1_Mbps_TC4_P":
                x.bandwidthProfile = "12/1 Mbps";
                break;
              case "D25_U5_Mbps_TC4_P":
                x.bandwidthProfile = "25/5 Mbps";
                break;
              case "D25_U5-10_Mbps_TC4_P":
                x.bandwidthProfile = "25/10 Mbps";
                break;
              case "D25-50_U5-20_Mbps_TC4_P":
                x.bandwidthProfile = "50/20 Mbps";
                break;
              case "Home Fast":
                x.bandwidthProfile = "100/20 Mbps";
                break;
              case "D25-100_U5-40_Mbps_TC4_P":
                x.bandwidthProfile = "100/40 Mbps";
                break;
              case "D25-100_U5-20_Mbps_TC4_P":
                x.bandwidthProfile = "100/20 Mbps";
                break;
            }
          }
        } else if (x.technologyType === "FTTC") {
          if (x.fibreUpgrade === "Yes") {
            switch (x.bandwidthProfile) {
              case "D100_U40_Mbps_TC4_P":
                x.bandwidthProfile = "100/40 Mbps";
                break;
              case "D250_U100_Mbps_TC4_P":
                x.bandwidthProfile = "250/100 Mbps";
                break;
              case "Home Fast":
                x.bandwidthProfile = "100/20 Mbps";
                break;
              case "Home Superfast":
                x.bandwidthProfile = "250/25 Mbps";
                break;
              case "Home Ultrafast":
                x.bandwidthProfile = "1000/50 Mbps";
                break;
            }
          } else {
            switch (x.bandwidthProfile) {
              case "D12_U1_Mbps_TC4_P":
                x.bandwidthProfile = "12/1 Mbps";
                break;
              case "D25_U5_Mbps_TC4_P":
                x.bandwidthProfile = "25/5 Mbps";
                break;
              case "D25_U10_Mbps_TC4_P":
                x.bandwidthProfile = "25/10 Mbps";
                break;
              case "D25_U5-10_Mbps_TC4_P":
                x.bandwidthProfile = "25/10 Mbps";
                break;
              case "D50_U20_Mbps_TC4_P":
                x.bandwidthProfile = "50/20 Mbps";
                break;
              case "D25-50_U5-20_Mbps_TC4_P":
                x.bandwidthProfile = "50/20 Mbps";
                break;
              case "Home Fast":
                x.bandwidthProfile = "100/20 Mbps";
                break;
              case "D50-100_U20-40_Mbps_TC4_P":
                x.bandwidthProfile = "100/40 Mbps";
                break;
              case "D25-100_U5-40_Mbps_TC4_P":
                x.bandwidthProfile = "100/40 Mbps";
                break;
            }
          }
        } else if (x.technologyType === "Fixed Wireless") {
          switch (x.bandwidthProfile) {
            case "D12_U1_Mbps_TC4_P":
              x.bandwidthProfile = "12/1 Mbps";
              break;
            case "D25_U5_Mbps_TC4_P":
              x.bandwidthProfile = "25/5 Mbps";
              break;
            case "FWPlus_TC4_P":
              x.bandwidthProfile = "FW Plus";
              break;
            case "FW Home Fast":
              x.bandwidthProfile = "250/20 Mbps";
              break;
            case "FW Superfast":
              x.bandwidthProfile = "400/40 Mbps";
              break;
          }
        } else if (x.technologyType === "HFC") {
          switch (x.bandwidthProfile) {
            case "D12_U1_Mbps_TC4_P":
              x.bandwidthProfile = "12/1 Mbps";
              break;
            case "D25_U5_Mbps_TC4_P":
              x.bandwidthProfile = "25/5 Mbps";
              break;
            case "D25_U10_Mbps_TC4_P":
              x.bandwidthProfile = "25/10 Mbps";
              break;
            case "D50_U20_Mbps_TC4_P":
              x.bandwidthProfile = "50/20 Mbps";
              break;
            case "D100_U40_Mbps_TC4_P":
              x.bandwidthProfile = "100/40 Mbps";
              break;
            case "D250_U100_Mbps_TC4_P":
              x.bandwidthProfile = "250/100 Mbps";
              break;
            case "Home Fast":
              x.bandwidthProfile = "500/50 Mbps";
              break;
            case "Home Superfast":
              x.bandwidthProfile = "750/50 Mbps";
              break;
            case "Home Ultrafast":
              x.bandwidthProfile = "1000/100 Mbps";
              break;
          }
        }
      }
    });

    state.reportData = items;
  }
};

export const actions = {
  async getSqResponse({ dispatch }, custRef) {
    try {
      let result = await HTTP.post(`OptusNBN/GetSqResponse/${custRef}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getRequestData({ dispatch }, custRef) {
    try {
      let result = await HTTP.post(`OptusNBN/GetRequestData/${custRef}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setOriginal({ commit }, val) {
    commit("SET_ORIGINAL", val);
  },
  setEditForm({ commit }, val) {
    commit("SET_EDITING", val);
  },
  setUbCustomers({ commit }, data) {
    commit("SET_UB_CUSTOMERS", data);
  },
  async getUBCustomers({ dispatch, commit }, data) {
    if (data.keyword === null) data.keyword = "all";
    try {
      let result = await HTTP.get(
        `OptusNBN/GetUBCustomers/${data.id}/${data.keyword}`
      );

      if (result.data) commit("SET_UB_CUSTOMERS", result.data);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  updateOfferContact({ commit }, data) {
    commit("UPDATE_OFFER_CONTACT", data);
  },
  async getCustomerRefs({ dispatch }, field) {
    try {
      let refs = await HTTP.get(`OptusNBN/GetCustomerRefs/${field}`);
      return Promise.resolve(refs.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getCustomerRefs5G({ dispatch }, field) {
    try {
      let refs = await HTTP.get(`OptusNBN/GetCustomerRefs5G/${field}`);

      return Promise.resolve(refs.data);
    } catch (e) {
      let message = "";

      if (!e.response) message = e.message;
      else message = e.response.data.Message;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setOrderType({ commit }, type) {
    commit("SET_ORDER_TYPE", type);
  },

  async getWholesalers({ commit, dispatch }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });

    try {
      let wholesalers = await HTTP.get("OptusNBN/GetWholesalers");
      commit("SET_WHOLESALERS", wholesalers.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(wholesalers.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getFeatures({ dispatch, commit }, wholesalerId) {
    dispatch("processLoader/setProcessActive", {}, { root: true });

    try {
      let features = await HTTP.get(`OptusNBN/GetFeatures/${wholesalerId}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });

      if (features.data !== "" || features.data !== null) {
        commit("SET_FEATURE", features.data);
      }

      return Promise.resolve(features);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  resetFeature({ commit }) {
    commit("RESET_FEATURE");
  },
  async getNBNOrders({ dispatch }, paging = { pageNo: 1, pageSize: 25 }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let orders = await HTTP.post("OptusNBN/GetNBNOrders", paging);
      let orderData = [];

      if (orders.data.items && orders.data.items.length > 0)
        orderData = orders.data;

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(orderData);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setSelectedOrder({ commit }, data) {
    commit("SET_SELECTED_ORDER", data);
  },
  async addressQuery({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/QueryAddress", payload);
      if (result.data.data.addresses.length === 0) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: "No address match", color: "error" },
          { root: true }
        );
      }
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) {
        if (!e.message) message = "Please try again.";
        else message = e.message;
      } else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async nbnAddressQuery({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/NbnQueryAddress", payload);
      if (result.data.data.length === 0) {
        dispatch(
          "httpResponse/setHttpResponse",
          {
            text: "No matching addresses found with NBNco",
            color: "error"
          },
          { root: true }
        );
      }
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) {
        if (!e.message) message = "Please try again.";
        else message = e.message;
      } else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setAddressQueryResult({ commit }, data) {
    commit("SET_ADDRESS_QUERY_RESULT", data);
  },
  setLocationID({ commit }, payload) {
    commit("SET_LOCATION_ID", payload);
  },
  async serviceQualification5G({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let sq = await HTTP.post("OptusNBN/ServiceQualification5G", payload);
      if (sq.data.success) {
        commit(
          "SET_SQ_5G",
          sq.data.data.body.queryServiceQualificationResponse.sqResults
        );
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: sq.data.message, color: "error" },
          { root: true }
        );
      }

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(sq.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  set5gSqResult({ commit }, data) {
    commit("SET_SQ_5G", data);
  },
  reset5gSq({ commit }) {
    commit("RESET_5G_SQ");
  },
  setSqResult({ commit }, data) {
    commit("SET_SQ_RESULT", data);
  },
  async serviceQualification({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let sq = await HTTP.post("OptusNBN/ServiceQualification", payload);
      commit("SET_SQ_RESULT", sq.data.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(sq.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async serviceQualificationNbn({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let sq = await HTTP.post("OptusNBN/NbnServiceQualification", payload);
      if (sq.data.success) {
        commit("SET_SQ_NBN", sq.data.data);
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: sq.data.message, color: "error" },
          { root: true }
        );
      }

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(sq.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setFormattedSQResult({ commit }, data) {
    commit("SET_FORMATTED_SQ_RESULT", data);
  },
  setFormattedNbnSQResult({ commit }, data) {
    commit("SET_FORMATTED_SQ_NBN_RESULT", data);
  },
  resetFormattedSQResult({ commit }) {
    commit("RESET_FORMATTED_SQ_RESULT");
  },
  setEnhancedSq({ commit }, data) {
    commit("SET_ENHANCED_SQ", data);
  },
  async createNewOrder({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/CreateOrder", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async createCustomisedOffer({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/CreateCustomisedOffer", payload);

      if (!result.data.success) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: result.data.message, color: "error" },
          { root: true }
        );
      }
      dispatch("setCustomizedOffer", result.data.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async submit5GOrder({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/Reserve5G", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setCustomizedOffer({ commit }, data) {
    commit("SET_CUSTOMIZED_OFFER_RESULT", data);
  },
  updateCustomizedOffer({ commit }, details) {
    commit("UPDATE_CUSTOMIZED_OFFER_RESULT", details);
  },
  // async createTemplatedEmail({ dispatch }, payload) {
  //   dispatch("processLoader/setProcessActive", {}, { root: true });
  //   try {
  //     let result = await HTTP.post("OptusNBN/SendEmail", payload);
  //     dispatch("processLoader/setProcessInactive", {}, { root: true });
  //     return Promise.resolve(result.data);
  //   } catch (e) {
  //     let message = "";
  //     if(!e.response) message = e.message;
  //     else message = Object.values(e.response.data.errors)[0].toString();
  //     dispatch(
  //       "httpResponse/setHttpResponse",
  //       { text: message, color: "error" },
  //       { root: true }
  //     );
  //     dispatch("processLoader/setProcessInactive", {}, { root: true });
  //     return Promise.reject(e);
  //   }
  // },
  async getOrderDetails({ dispatch, commit }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/QueryOrderDetails", payload);
      commit("SET_ORDER_DETAILS", result.data.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  resetHasNtd({ commit }) {
    commit("RESET_HASNTD");
  },
  resetHasSectorId({ commit }) {
    commit("RESET_HASSECTORID");
  },
  setMsnList({ commit }, data) {
    commit("SET_MSN_LIST", data);
  },
  async getMsnList({ dispatch, commit }, accountId) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(`OptusNBN/GetAvailableMsn/${accountId}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      commit("SET_MSN_LIST", result.data.data);
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setSimList({ commit }, data) {
    commit("SET_SIM_LIST", data);
  },
  async getSimList({ dispatch, commit }, accountId) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(`OptusNBN/GetAvailableUsim/${accountId}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      commit("SET_SIM_LIST", result.data.data);
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = e.response.statusText;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async sendAvailableSimEmail({ dispatch }, length) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(`OptusNBN/SendAvailableSimEmail/${length}`);
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  set5gRatePlans({ commit }, data) {
    commit("SET_5G_RATE_PLANS", data);
  },
  async get5gRatePlans({ dispatch, commit }, value) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.get(`OptusNBN/GetRatePlans/${value}`);
      commit("SET_5G_RATE_PLANS", result.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async get5GOrderDetails({ dispatch }, msn) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(`OptusNBN/OptusServiceEnquiry/${msn}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async checkRadiusUsername({ dispatch }, radiusUsername) {
    try {
      let result = await HTTP.post(
        `OptusNBN/CheckRadiusUsername/${radiusUsername}`
      );
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async createRadiusAccount({ dispatch }, payload) {
    try {
      let result = await HTTP.post("OptusNBN/CreateRadiusAccount", payload);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async updateOnIseekValue({ dispatch }, payload) {
    try {
      let result = await HTTP.post(
        `OptusNBN/UpdateOnIseek/${payload.customerAuthReference}`
      );
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getNbnConnectOrders({ dispatch }, payload) {
    try {
      let result = await HTTP.post("OptusNBN/GetNbnConnectOrders", payload);
      if (result.data.success) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: result.data.message, color: "success" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
        return Promise.resolve(result.data.data);
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: result.data.message, color: "error" },
          { root: true }
        );
        dispatch("processLoader/setProcessInactive", {}, { root: true });
        return Promise.reject(result.data.message);
      }
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  resetFormattedSqNbnResult({ commit }) {
    commit("RESET_FORMATTED_SQ_NBN_RESULT");
  },
  async submitServiceTest({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/SubmitServiceTest", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      if (result) {
        //
      } else {
        dispatch(
          "httpResponse/setHttpResponse",
          {
            text: "Failed to submit a Service Test request",
            color: "error"
          },
          { root: true }
        );
      }
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getServiceTestResult({ dispatch }, payload) {
    try {
      let result = await HTTP.post("OptusNBN/GetServiceTestResult", payload);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  setReferenceInvalid({ commit }, data) {
    commit("SET_REFERENCE_INVALID", data);
  },
  async getExportableNbnOrders({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post(
        "OptusNBN/QueryExportableNbnOrders",
        payload
      );
      dispatch("mapBandwidthProfile", result.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async searchRadiusUsernames({ dispatch, commit }, radiusUserName) {
    try {
      if (radiusUserName != null && radiusUserName.length >= 3) {
        let radiusUserNames = await HTTP.post(
          `OptusNBN/GetRadiusUserNames/${radiusUserName}`
        );
        commit("SET_RADIUS_USERNAME_RESULTS", radiusUserNames.data);
        return Promise.resolve(radiusUserNames.data);
      }
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getRadiusPassword({ dispatch }, radiusUserName) {
    try {
      if (radiusUserName != null && radiusUserName.length >= 3) {
        let password = await HTTP.post(
          `OptusNBN/GetRadiusPassword/${radiusUserName}`
        );
        return Promise.resolve(password.data);
      }
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getServiceRadiusStatus({ dispatch }, payload) {
    try {
      let result = await HTTP.post("OptusNBN/GetServiceRadiusStatus", payload);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getCvcIds({ dispatch }, payload) {
    try {
      let result = await HTTP.post("OptusNBN/GetCvcIds", payload);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async removeServiceFromUsherAsync({ dispatch }, payload) {
    try {
      let result = await HTTP.post(
        `OptusNBN/RemoveUsherService/${payload.avdid}`,
        null,
        {
          params: {
            orderId: payload.orderId,
            id: payload.id || undefined
          }
        }
      );
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getStaticIp({ dispatch }, radiusUsername) {
    try {
      let result = await HTTP.post(`OptusNBN/GetStaticIp/${radiusUsername}`);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async getMigrationResult({ dispatch }, payload) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let result = await HTTP.post("OptusNBN/GetMigrationOverview", payload);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async GetTransferredDate({ dispatch, commit }, payload) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let result = await HTTP.get(`OptusNBN/GetTransferredDate/${payload}`);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      commit("SET_TRANSFERRED_DATE", result.data);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async ReverseTransferService({ dispatch }, payload) {
    try {
      dispatch("processLoader/setProcessActive", {}, { root: true });
      let result = await HTTP.post(
        `OptusNBN/ReverseTransferService/${payload.orderId}`,
        null,
        {
          params: { id: payload.id || undefined }
        }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = e.response.data;
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  checkHardwareModem({ commit }, order) {
    commit("CHECK_HARDWARE_MODEM", order);
  },
  resetRadiusUsernameResults({ commit }) {
    commit("RESET_RADIUS_USERNAME_RESULTS");
  },
  setOldOrder({ commit }, value) {
    commit("SET_OLD_ORDER", value);
  },
  setIsDuplicate({ commit }, value) {
    commit("SET_IS_DUPLICATE", value);
  },
  setFibreCheckbox({ commit }, payload) {
    commit("SET_FIBRE_CHECKBOX", payload);
  },
  setUserInternal({ commit }, wholesalerId) {
    commit("SET_USER_INTERNAL", wholesalerId);
  },
  async enhanceServiceQualificationNbn({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let sq = await HTTP.post(
        "OptusNBN/NbnEnhanceServiceQualification",
        payload
      );
      if (!sq.data.success) {
        dispatch(
          "httpResponse/setHttpResponse",
          { text: sq.data.message, color: "error" },
          { root: true }
        );
      }

      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(sq.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  mapBandwidthProfile({ commit }, payload) {
    commit("MAP_BANDWIDTH_PROFILE", payload);
  }
  //   async serviceOffer({ dispatch}, payload) {
  //     dispatch("processLoader/setProcessActive", {}, { root: true });
  //     try {
  //       let result = await HTTP.post("OptusNBN/CreateCustomisedOffer", payload);
  //       dispatch("processLoader/setProcessInactive", {}, { root: true });
  //       return Promise.resolve(result.data.data);
  //     } catch (e) {
  //       dispatch(
  //         "httpResponse/setHttpResponse",
  //         { text: Object.values(e.response.data.errors)[0].toString(), color: "error" },
  //         { root: true }
  //       );
  //       dispatch("processLoader/setProcessInactive", {}, { root: true });
  //       return Promise.reject(e);
  //     }
  //   },
};
